import {
  withTranslation,
} from 'react-i18next';

import ChampionshipsListItemView from './ChampionshipsListItemView';

const TranslatedComponent = withTranslation()(ChampionshipsListItemView);

const Component = TranslatedComponent;

export default Component;
